import React, {Fragment, useEffect} from "react";
import {useForm} from "../utils/FormUtils";
import EADialog from "./EADialog";
import EAButton from "./EAButton";
import LoadingPlaceholder from "./LoadingPlaceholder";

/**
 * Dialog zum Bearbeiten, betrachten und Hinzufügen eines neuen Elements.
 * @param open ob der Dialog offen ist
 * @param title Der anzuzeigende Titel
 * @param buildContent Funktion, welche die formfactory bekommt, um den Inhalt zu bauen
 * @param submitTitle Speichern-Schaltfläche-Text
 * @param renderAdditionalActions weitere Komponenten in der ButtonBar
 * @param onClose Funktion, welche beim Abbrechen ausgeführt werden soll
 * @param obj das darzustellende Element
 * @param onSaveobj Funktion, welche aufgerufen wird, wenn die Speichern-Schaltfläche geklickt wird und die Validierung erfolgreich durchgelaufen ist
 * @param readOnly, Ob der Dialog lesend ist
 * @param schema das Schema zur Validierung des Objekts
 * @param loading Wenn True, wird eine Bearbeitung nicht ermöglicht
 * @returns {JSX.Element}
 * @constructor
 */
export default function EACrudDialog({
                                         open,
                                         title,
                                         buildContent,
                                         submitTitle,
                                         renderAdditionalActions,
                                         onClose,
                                         obj,
                                         onSaveobj,
                                         readOnly,
                                         schema,
                                         loading = false,
                                     }) {
    const {values, setValues, formFactory, validate, setErrors} = useForm({onSubmit: null, schema, readonly: readOnly});

    useEffect(() => {
        setValues(obj);
    }, [obj, setValues]);

    /**
     * Validierungsfehler zurücksetzen wenn Dialog geschlossen wird
     */
    useEffect(() => {
        setErrors({});
    }, [open, setErrors]);

    function handleSubmit() {
        if (!validate()) {
            onSaveobj(values);
        }
    }

    return (
        <EADialog
            open={open}
            closeFunction={onClose}
            testId="crudDlg"
            titleChildren={title}
            content={loading ? <LoadingPlaceholder/> : buildContent(formFactory)}
            buttons={
                <Fragment>
                    {renderAdditionalActions && renderAdditionalActions()}
                    <EAButton id="crudDlg-Abbrechen" label="Abbrechen" onClick={onClose}/>
                    {!readOnly && (
                        <EAButton
                            loading={loading}
                            disabled={loading}
                            id="crudDlg-Submit"
                            label={submitTitle}
                            onClick={handleSubmit}
                            color="primary"
                        />
                    )}
                </Fragment>
            }
        />
    );
}
